import axiosInstance from "../axiosInstance";

export const lostSalesService = {
  availability: async (clientId) => {
    const response = await axiosInstance.get("/lost-sales", {
      suppressErrorToast: true,
      params: clientId ? { client: clientId } : undefined,
    });
    return response.data;
  },
  /**
   * Warehouse-eligible population for "All Products" (product-level) and
   * "All SKUs" (SKU-level). Eligibility is period-scoped, so the dates are
   * required.
   * GET /lost-sales?client=&warehouse_id=&start_date=&end_date=&eligible_products=true
   */
  eligibleProducts: async (clientId, warehouseId, startDate, endDate) => {
    const response = await axiosInstance.get("/lost-sales", {
      suppressErrorToast: true,
      params: {
        client: clientId,
        warehouse_id: warehouseId,
        start_date: startDate,
        end_date: endDate,
        eligible_products: true,
      },
    });
    return response.data;
  },
  analyze: async (payload) => {
    const response = await axiosInstance.post("/lost-sales", payload, {
      suppressErrorToast: true,
    });
    return response.data;
  },
  analyzeBulk: async (payload) => {
    const response = await axiosInstance.post(
      "/lost-sales",
      { ...payload, bulk: true },
      { suppressErrorToast: true },
    );
    return response.data;
  },
};
